'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** /Users/dan/p/react-devtools/~/react/react.js
 ** module id = 6
 ** module chunks = 0
 **/